module.exports = __webpack_public_path__ + "static/media/stockhausen_graz_10.55021799.jpg";